import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { AppContext } from 'src/components/app-context';
import { PersonalizedRecommendationsFragment, Product } from 'src/types';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';
import { ProductsSection } from 'src/components/products-section';
import { filterCategories } from 'src/areas/landing-page/filter-categories';
import { productNavigation } from 'src/areas/product/actions/product';
import { POPULAR_CLICK } from 'src/globals/helpers/navigation-action';

type Props = {
  products?: Recommendations['products'];
  negativeMargin?: boolean;
};

type Recommendations = NonNullable<
  PersonalizedRecommendationsFragment['fallbackRecommendations']
>;

const FallbackProductRecommendations: React.FC<Props> = props => {
  const { products = { nodes: [] } } = props;
  const { t, linkTo } = useContext(AppContext);
  const dispatch = useDispatch();

  if (!(products && products.nodes) || !products.nodes.length) {
    return null;
  }

  const productsItems = filterCategories(products.nodes as Product[]);

  const internalLinkTo = linkTo('virtualCategory', { id: 'v100' });

  const trackHeaderClick = (data: { link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.FALLBACK_RECOMMENDATIONS_HEADER,
      nextPage: data.link,
    });
  };

  const trackProductCardClick = (data: { index: number; link: string }) => {
    dispatch(productNavigation(POPULAR_CLICK, data.index + 1));
    trackInternalNavigationClick({
      scope: InternalNavigationScope.FALLBACK_RECOMMENDATIONS_PRODUCT_CARD,
      nextPage: data.link,
      index: data.index,
    });
  };

  return (
    <ProductsSection
      products={productsItems}
      title={t('landing', 'hot-products.title')}
      linkPath={internalLinkTo}
      linkTitle={t('common', 'button.show-all-popular-products')}
      shouldLazyLoadImages
      dataTestType="product-recommendations"
      onHeaderLinkClick={trackHeaderClick}
      onProductCardClick={trackProductCardClick}
      negativeMargin={props.negativeMargin}
    />
  );
};

export default FallbackProductRecommendations;
